<template>
    <div id="passWord">
      <div class="box-center" v-if="seted">
        请输入旧密码
      </div>
      <template  v-else>
        <div class="box-center" v-if="show">
          请输入密码
        </div>
        <div class="box-center" v-else>
          请确认密码
        </div>
      </template>

        <van-password-input
          :value="value"
          info="密码为 6 位数字"
          @focus="showKeyboard = true"
        />
        <van-number-keyboard
          :show="showKeyboard"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = false"
        />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { PasswordInput ,NumberKeyBoard } from 'vant';
    Vue.use(PasswordInput);

    export default {
        name: 'passWord',
        data() {
            return {
              seted:true,
              oldpass:'',
              value: '',
              showKeyboard: true,
              passWord1:'',
              passWord2:'',
              show:true
            }
        },
        created() {

        },
        mounted() {


        },
        methods: {
            onInput(key) {
              this.value = (this.value + key).slice(0, 6);
              if(this.value.length == 6){
                if(this.seted){
                  this.oldpass = this.value;
                  this.seted = false;
                  this.value = '';
                }else{
                  if(!this.passWord1){
                    this.passWord1 = this.value;
                    this.value = '';
                    this.show = false;
                  }else{
                    this.passWord2 = this.value;
                    this.value = '';
                    this.showKeyboard = false;
                  }
                }
              }
            },
            onDelete() {
              this.value = this.value.slice(0, this.value.length - 1);
            }
        }
    }
</script>

<style scoped>

</style>